export enum ETypeNote {
  ConditionOrDisease = 'CONDICAO_DOENCA',
  Medicine = 'MEDICAMENTO',
}

const inputPickerOptions: {
  label: string;
  value: string;
}[] = [
  {
    label: 'Condição/Doença',
    value: ETypeNote.ConditionOrDisease,
  },
  {
    label: 'Medicamento',
    value: ETypeNote.Medicine,
  },
];

export const typeNote = { inputPickerOptions };
